import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// Constants - functions
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import { MainDiv } from "./styles";
import Loader from "../../../loader";
import Axios from "../../../../config/axios";
import Title from "../../../title";
import PredictedRecoveryPlot from "./sections/predictedRecoveryPlot";
import RecoveryClassificationPlot from "./sections/recoveryClassificationPlot";

const PatientModel = () => {
  const [prognosisData, setPrognosisData] = useState([]);
  const [isLoadingPrognosisData, setIsLoadingPrognosisData] = useState(true);
  const { patientId } = useParams();

  // Fetch Prognosis data
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/recsys/get-prognosis-prediction/${patientId}`)
      .then(({ data }) => {
        setPrognosisData(data);
        setIsLoadingPrognosisData(false);
      })
      .catch((error) => {
        console.log("Get prognosis data: ", error);
      });

    return () => {
      setPrognosisData([]);
      setIsLoadingPrognosisData(true);
    };
  }, [patientId]);

  return (
    <>
      <Title title={"PATIENT MODEL"} marginBottom="10px" />
      {isLoadingPrognosisData ? (
        <Loader />
      ) : (
        <MainDiv>
          <PredictedRecoveryPlot prognosisData={prognosisData} />
          <RecoveryClassificationPlot prognosisData={prognosisData} />
        </MainDiv>
      )}
    </>
  );
};

export default PatientModel;
